import React from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { FormGroup } from 'reactstrap';
import { ButtonWithLoadingIcon } from '../../../common/ButtonWithLoadingIcon';
import { Colxx } from '../../../common/CustomBootstrap';
import { CommonFormInput } from '../../../common/CustomFormComponents';
// components

// end of components

const profileEditSchema = Yup.object().shape({
  email_paypal: Yup.string().required('Please paypal account id').nullable(),
  email_venmo: Yup.string().required('Please venmo account id').nullable(),
});

export const AccountsEdit = ({ userData, isUpdating, onSubmit }) => {
  const initialValues = {
    email_paypal: userData.email_paypal || '',
    email_venmo: userData.email_venmo || '',
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={profileEditSchema}
    >
      {({
        values,
        errors,
        isSubmitting,
        touched,
        setFieldValue,
        setFieldTouched,
      }) => {
        return (
          <Form className='mb-4'>
            <FormGroup row>
              <Colxx sm={12}>
                <CommonFormInput
                  label='PayPal email'
                  name='email_paypal'
                  id='email_paypal'
                  showError={errors.email_paypal && touched.email_paypal}
                  error={errors.email_paypal}
                />
              </Colxx>
              <Colxx sm={12}>
                <CommonFormInput
                  label='Venmo email'
                  name='email_venmo'
                  id='email_venmo'
                  showError={errors.email_venmo && touched.email_venmo}
                  error={errors.email_venmo}
                />
              </Colxx>
            </FormGroup>

            <FormGroup row>
              <Colxx sm={12} className='d-flex justify-content-center'>
                <ButtonWithLoadingIcon
                  disabled={isUpdating}
                  type='submit'
                  loading={isUpdating}
                  color='primary'
                  size='sm'
                  height={36}
                  className={'px-5'}
                >
                  UPDATE
                </ButtonWithLoadingIcon>
              </Colxx>
            </FormGroup>
          </Form>
        );
      }}
    </Formik>
  );
};
